$(() => {
  $('[data-tab]').click((event) => {
    $('[data-input="goto"]').val($(event.target).data('tab'));
    $('form').submit();
  });

  // bootstrap tabs
  $('.nav[data-hash-update] .nav-item .nav-link').on('click', (e) => {
    let hash = e.target.dataset.bsTarget;
    location.hash = hash
  });

  if ($('.nav[data-hash-update]').length) {
    let hash = location.hash;
    let button = hash.length ? $(`.nav[data-hash-update] .nav-item .nav-link[data-bs-target="${hash}"]`) :
      $('.nav[data-hash-update] .nav-item:first-child .nav-link');

    if (button.length) {
      let tab = new bootstrap.Tab(button)

      tab.show()
    }
  }
});
